import { BffApiCreateItemError } from '../../../../types';
import { useBffCreateQuery } from '../../../common/reactQuery/hooks/useBffCreateQuery';
import { RenderGenerationsBffUrl } from '../../RenderGenerationsBffUrl';
import {
  CreateRenderGenerationInput,
  CreateRenderGenerationResponse
} from '../../renderGenerationsTypes';

function useCreateRenderGeneration<InputType = CreateRenderGenerationInput>() {
  const {
    createQueryData,
    createQuery,
    createQueryReset,
    createQueryError,
    createQueryErrorMessage,
    createQueryLoading
  } = useBffCreateQuery<
    InputType,
    CreateRenderGenerationResponse,
    BffApiCreateItemError,
    CreateRenderGenerationResponse
  >({
    url: RenderGenerationsBffUrl.create()
  });

  return {
    createRenderGenerationData: createQueryData,
    createRenderGenerationError: createQueryError,
    createRenderGenerationLoading: createQueryLoading,
    createRenderGenerationErrorMessage: createQueryErrorMessage,
    createRenderGeneration: createQuery,
    createRenderGenerationReset: createQueryReset
  };
}

export default useCreateRenderGeneration;
